var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCohort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77734 1.83094C8.19535 1.35705 8.74776 1.02167 9.36106 0.869449C9.97437 0.717227 10.6195 0.755373 11.2106 0.978811C11.8017 1.20225 12.3107 1.60039 12.6699 2.12025C13.0292 2.6401 13.2216 3.25703 13.2216 3.88894C13.2216 4.52086 13.0292 5.13778 12.6699 5.65764C12.3107 6.1775 11.8017 6.57564 11.2106 6.79908C10.6195 7.02252 9.97437 7.06066 9.36106 6.90844C8.74776 6.75622 8.19535 6.42084 7.77734 5.94694M10.1107 14.7778H0.777344V14.0001C0.777344 12.7624 1.26901 11.5754 2.14418 10.7002C3.01935 9.82505 4.20633 9.33339 5.44401 9.33339C6.68169 9.33339 7.86867 9.82505 8.74384 10.7002C9.61901 11.5754 10.1107 12.7624 10.1107 14.0001V14.7778ZM10.1107 14.7778H14.7773V14.0001C14.7775 13.1808 14.5619 12.376 14.1524 11.6665C13.7428 10.957 13.1537 10.3678 12.4443 9.95811C11.7349 9.54845 10.9301 9.33276 10.1108 9.33273C9.29161 9.3327 8.48682 9.54833 7.77734 9.95794M8.55512 3.88894C8.55512 4.71406 8.22734 5.50539 7.6439 6.08883C7.06045 6.67228 6.26913 7.00006 5.44401 7.00006C4.61889 7.00006 3.82757 6.67228 3.24412 6.08883C2.66068 5.50539 2.3329 4.71406 2.3329 3.88894C2.3329 3.06383 2.66068 2.2725 3.24412 1.68906C3.82757 1.10561 4.61889 0.777833 5.44401 0.777833C6.26913 0.777833 7.06045 1.10561 7.6439 1.68906C8.22734 2.2725 8.55512 3.06383 8.55512 3.88894Z",
    stroke: "#A1A1AA",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohort);
export default __webpack_public_path__ + "static/media/cohort.f53f4ffc0564dbbd16b5c2deca46ac7a.svg";
export { ForwardRef as ReactComponent };